import React, { useState } from 'react';
import { Plus, Edit2, Trash2, Search } from 'lucide-react';
import { adminProducts } from '../adminData';

function AdminProducts() {
  const [search, setSearch] = useState('');
  const filtered = adminProducts.filter(p => p.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Products</h1>
          <p>Manage your product catalog, pricing and stock.</p>
        </div>
        <button className="admin-btn-primary">
          <Plus size={16} /> Add Product
        </button>
      </div>

      <div className="admin-card">
        <div className="admin-toolbar">
          <div className="admin-search-box small">
            <Search size={16} />
            <input
              type="text"
              placeholder="Search products..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Category</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Sold</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(p => (
                <tr key={p.id}>
                  <td className="admin-td-name">{p.name}</td>
                  <td>{p.category}</td>
                  <td className="admin-td-gold">{p.price} SAR</td>
                  <td>
                    <span className={p.stock > 30 ? 'admin-badge-good' : 'admin-badge-warn'}>
                      {p.stock} units
                    </span>
                  </td>
                  <td>{p.sold}</td>
                  <td>
                    <div className="admin-row-actions">
                      <button className="admin-icon-action"><Edit2 size={14} /></button>
                      <button className="admin-icon-action danger"><Trash2 size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminProducts;
